import { HomeIcon } from "@heroicons/react/24/outline";

const PagesRoutes = [
    {
        index: true,
        path: "/",
        async lazy() {
            const component = await import("../../pages/Dashboard/Dashboard");
            return {
                Component: component.default,
            };
        },
        showChildren: false,
        sidebarMenu: true,
        displayName: "Dashboard",
        icon: HomeIcon,
    },
    {
        path: "profile",
        async lazy() {
            const component = await import(
                "../../pages/userManagement/profile/UserProfile"
            );
            return {
                Component: component.default,
            };
        },
        exact: true,
    },
];

export default PagesRoutes;
